module.exports = __webpack_public_path__ + "img/Flag_of_Antigua_and_Barbuda.7123baf3.svg";